// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NnX7","textarea":"styles_textarea__34XlF"};